import Constants from "common/constant";

export const TypingIndicator = () => {
  return (
    <div className="flex flex-row items-end gap-3">
      {/* アバター */}
      <div className="flex-col-center w-[52px] h-[52px] rounded-full bg-white flex-shrink-0 drop-shadow-[1px_1px_2px_rgba(63,74,97,0.4)] overflow-hidden">
        <img
          src={`${Constants.assetHost}/assets/images/little_pal.png`}
          className="w-full h-full object-contain"
        />
      </div>

      {/* タイピングインジケーター */}
      <div className="flex flex-row items-center gap-[6px] py-4 px-5 bg-gray-20 rounded-[20px] rounded-bl-[6px]">
        <div className="typing-dot typing-dot-1" />
        <div className="typing-dot typing-dot-2" />
        <div className="typing-dot typing-dot-3" />
      </div>
    </div>
  );
};
